/**
 * PageBlog.js
 */

import $ from 'jquery';

class PageBlog {
    constructor() {
        const _this = this
        window.setTimeout(() => {
            this.setTopFilter();
        }, 200);

        $(window).resize(function() {
            _this.setTopFilter();
        });
        this.hideFilterOptions();
    }

    setTopFilter() {
        this.adminBar = $('#wpadminbar');
        this.header = $('.js-header-bar');
        this.filterBlog = $('.js-filter');
        let heighthHeader = 0;
        let heightAdminBar = 0;

        if (this.header.length) {
            heighthHeader = $(this.header).height();
        }

        if (this.adminBar.length) {
            heightAdminBar = $(this.adminBar).height();
        }

        if (this.filterBlog.length) {
            $(this.filterBlog).css("top", (heightAdminBar + heighthHeader - 1) + "px");
        }
    }

    hideFilterOptions (limit = 5) {
        $(document).on('facetwp-loaded', function() {
            if (window.location.href.includes('fwp_')) {
                return;
            }
            $('.facetwp-facet').each(function() {
                const facet = $(this);
                const $checkboxEls = facet.find('.facetwp-checkbox');
                if ($checkboxEls.length) {
                    $checkboxEls.each(function () {
                        const $countEl = $(this).find('.facetwp-counter');
                        if ($countEl && parseInt($countEl.text().replace(/[^0-9]/g,'')) <= limit) {
                            $(this).remove();
                        }
                    })
                }
            })
        });
    }
}

new PageBlog();
